import request from "@/utils/request";

export function AddUserLabel(data) {
  return request({
    url: `/UCenter/AddUserLabel`,
    method: "post",
    data,
  });
}
export function GetUserReport(data) {
  return request({
    url: `/UCenter/GetUserReport`,
    method: "post",
    data,
  });
}
export function AddUserReport(data) {
  return request({
    url: `/UCenter/AddUserReport`,
    method: "post",
    data,
  });
}
export function GetUserReportList(data) {
  return request({
    url: `/UCenter/GetUserReportList`,
    method: "post",
    data,
  });
}
export function GetUserReportInfo(data) {
  return request({
    url: `/UCenter/GetUserReportInfo`,
    method: "post",
    data,
  });
}
export function GetCashierUserList(data) {
  return request({
    url: `/UCenter/GetCashierUserList`,
    method: "post",
    data,
  });
}

/**
 * 上传图片文件
 *
 * @param file
 */
export function uploadFileApi(file) {
  const formData = new FormData();
  formData.append("file", file);
  return request({
    url: "/UCenter/UploadAvatar",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/**
 * 上传形象报告
 *
 * @param file
 */
export function uploadReport(formData) {
  return request({
    url: "/UCenter/UploadReportImage",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function addReportImage(data) {
  return request({
    url: `/UCenter/AddReportImage`,
    method: "post",
    data,
  });
}
export function combinePicture(data) {
  return request({
    url: `/UCenter/CombinePicture`,
    method: "post",
    data,
  });
}